export const buildLanguageRoute = (route: string, prefix: string): string => {
    if (prefix !== '') {
        return `/${prefix}${route}`;
    }
    return route;
};
